// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610252354/js/" + chunkId + "." + {"44":"92b90652","225":"7f8eda35","481":"51b72796","486":"612e3d35","770":"c267f20b"}[chunkId] + ".0.9862447045109994.chunk.js";
};